import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { actions } from 'builder/modules/panel'
import { actions as userActions } from 'builder/modules/user'

type GetPromotionActionsProps = {
  handleGetPromotionPage: () => void
  handleOpenBookCoach: () => void
}

export const useGetPromotionActions = (): GetPromotionActionsProps => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const handleGetPromotionPage = () => {
    dispatch(actions.setUIStatesConfigStatus({ promotion_plan_seen: true }))
    dispatch(userActions.setUIUserState({ promotionPlanSeen: true }))
    navigate('/career-plans/path-to-promotion')
  }

  const handleOpenBookCoach = () => {
    navigate('/career-coaching')
  }

  return {
    handleGetPromotionPage,
    handleOpenBookCoach,
  }
}
